<template>
  <v-col cols="12" sm="6" lg="6" class="mt-8 py-2">
    <v-card class="pa-2 primary4 card-radius" outlined>
      <v-card-title class="text-subtitle">
        <v-icon class="mr-2">$vuetify.icon.normal-bell</v-icon>
        <div class="ml-2">
          <div class="font-primaria font-weight-bold text-subtitle">Últimas atualizações - Dados Cadastrais</div>
          <div class="text-caption font-italic">Dados Cadastrais, Classificação, Hierarquia e Endereço</div>
        </div>      
      </v-card-title>
      <v-card-text :class="$vuetify.breakpoint.xs ? '' : 'mt-3'">
          <UpdatesTable 
            class="mt-4" 
            :showCheck="false" 
            :rows="rows"
            :rowsHeader="rowsHeader" 
            :pagina="pagina" 
            :qtPaginas="qtPaginas" 
            :qtResultados="qtResultados"
            :items="['05', '10', '15']" 
            :elementsPerPageProp="String(itemsPerPage)" 
            :editar="false"
            :ordenacaoAtual="ordenacaoAtual"
            :direcaoOrdenacao="direcaoOrdenacao"
            @clickButton="(obj) => click(obj)"
            @change-page="(obj) => changePage(obj)" 
            @change-element="(obj) => changeElement(obj)"
            @ordena="(obj) => changeOrdem(obj)" 
            ref="table"
            v-if="!loading" 
          />

        <component-loading
          style="height: 256px"
          v-if="loading" :value="loading" />

          <ModalHistorico 
            :title="titleModal"
            v-model="showModalHistorico" ref="historico" />

      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import DadosCadastrais from '@/services/MinhaUnimed/DadosCadastrais/ViewDadosCadastrais/DadosCadastrais';
import UpdatesTable from './UpdatesTable.vue';
import ModalHistorico from './ModalHistorico.vue';

export default {
  name: "UpdatesCard",
  components: {
    UpdatesTable,
    ModalHistorico
  },
  props: {
    unimedId: { type: Number, required: true },
    appConfig: { type: String, required: true },
  },
  data() {
    return {
      tokenBearer: localStorage.getItem('tokenBearer'),
      idUnimed: localStorage.getItem('idUnimed'),
      pagina: 1,
      qtPaginas: 1,
      qtResultados: 0,
      itemsPerPage: 5,
      loading: false,
      showModalHistorico: false,
      titleModal: '',
      selected: [],
      rowsHeader: [
        { text: "Data", icon: 'repeat' },
        { text: "Código", icon: 'repeat' },
        { text: "Nome Fantasia", icon: 'repeat' },
        { text: "Aba Atualizada", icon: 'repeat' },
        { text: "", value: "detalhes", sortable: false },
      ],
      rows: [],
      updates: [],
      ordem: 'desc',
      ordenacao: 'dataCriacao',
      ordenacaoAtual: 'dataCriacao',
      direcaoOrdenacao: 'desc',
    };
  },
  computed: {
    paginatedRows() {
      const startIndex = (this.pagina - 1) * this.itemsPerPage;
      return this.rows.slice(startIndex, startIndex + this.itemsPerPage);
    },
  },
  async beforeMount() {
    await this.loadDadosHistorico(`?tamanhoPagina=${this.itemsPerPage}&pagina=1&ordenacao=dataCriacao&direcaoOrdenacao=desc`);
  },
  methods: {
    async loadDadosHistorico(args = '') {
      this.loading = true;
      const dadosCadastrais = new DadosCadastrais(this.tokenBearer, this.appConfig, this.idUnimed);
        try {
          const res = await dadosCadastrais.getHistoricoDadosCadastrais(args);
          this.pagina = res.data.pagina;
          this.qtResultados = res.data.qtResultados;
          this.qtPaginas = res.data.qtPaginas;
          this.rows = res.data.conteudo.map((data) => {        
          const camposAlterados = data.camposAlterados.replace('\\"', "");
          return {
            id: data.id,
            codigo: data.codigo,
            data: this.extrairData(data.dataCriacao),
            nomeFantasia: data.unimed.nomeFantasia,
            abaAtualizada: `
              <span class="tooltip-wrapper" title='${camposAlterados}'>
                ${data.abasAlteradas.replace(', ', ' > ')}
              </span>
            `,
            detalhesTooltip: data.camposAlterados,
          }
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    changeOrdem(obj) {
      const campoOrdenacao = () => {
        switch (obj.index) {
          case 0: return 'dataCriacao';
          case 1: return 'unimed.id';
          case 2: return 'dadosCadastrais.nomeFantasia';
          case 3: return 'abasAlteradas';
          default: return 'dataCriacao';
        }
      };
      
      this.ordenacaoAtual = campoOrdenacao();
      this.direcaoOrdenacao = obj.ordem;
      
      this.loadDadosHistorico(
        `?tamanhoPagina=${this.itemsPerPage}&pagina=${this.pagina}&ordenacao=${this.ordenacaoAtual}&direcaoOrdenacao=${this.direcaoOrdenacao}`
      );
    },
    async changeElement(obj) {
      this.itemsPerPage = obj.elementsPerPage;
      await this.loadDadosHistorico(
        `?tamanhoPagina=${this.itemsPerPage}&pagina=1&ordenacao=${this.ordenacaoAtual}&direcaoOrdenacao=${this.direcaoOrdenacao}`
      );
    },
    async changePage(page) {
      if (page.currentPage !== this.pagina) {
        this.itemsPerPage = page.elementsPerPage;
        this.pagina = page.currentPage;
        await this.loadDadosHistorico(
          `?tamanhoPagina=${this.itemsPerPage}&pagina=${this.pagina}&ordenacao=${this.ordenacaoAtual}&direcaoOrdenacao=${this.direcaoOrdenacao}`
        );
      }
    },
    extrairData(dataHora) {
      return dataHora.split(' ')[0];
    },
    async click(obj) {
      let selected = obj.row;
      switch (obj.type) {
        case 'view':
          this.selected = selected;
          this.type = 'view';
          this.openHistorico(obj.row);
          break
        default:
          break
      }
    },
    openHistorico(selectedRow) {
      this.titleModal = 'Detalhe da alteração';
      this.showModalHistorico = true;
      this.$refs.historico.start(selectedRow.id, selectedRow.codigo, false);
    }
  },
};
</script>

<style scoped>
.title {
  font-size: 18px;
}

.under {
  text-decoration: underline !important;
}

.card-radius {
  border-radius: 20px !important;
}

.block-size200 {
  min-height: 200px;
}

.block-size70 {
  min-height: 70px;
}

.text-subtitle {
  color: #00995d !important;
  caret-color: #00995d !important;
}

.primary--text {
  color: #00995d !important;
  caret-color: #00995d !important;
}

.tooltip-wrapper {
  cursor: pointer;
  text-decoration: underline dotted;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
